module.exports = __webpack_public_path__ + "static/media/190.53d95fdb.webp";